/*
 * @Author: ex_zhouzy24 ex_zhouzy24@partner.midea.com
 * @Date: 2026-05-11 09:03:26
 * @LastEditors: ex_zhouzy24 ex_zhouzy24@partner.midea.com
 * @LastEditTime: 2026-06-16 13:33:27
 * @FilePath: \adm-tue:\mcsp\adm\midea-instructions-h5\src\api.js
 * @Description: Do not edit
 */
/**
 * Created by tanjj4 on 2018-2-8.
 */

const testServer = 'https://apisit.midea.com/MPLM/electronicmanual-server/';

const prdServer = process.env.BASE_API || 'https://api.midea.com/MPLM/electronicmanual-server/'; 
const rdmCustomerType = 'wechat/model-rdm';
const normalCustomerType = 'msInstruction/model?apikey=' + process.env.apikey;

const searchProduct = 'msInstruction/searchProduct?apikey=' + process.env.apikey;
const myBrowsingHistory = 'msWeChat/myBrowsingHistory?apikey=' + process.env.apikey;
const myCollections = 'msWeChat/myCollections?apikey=' + process.env.apikey;
const products = 'msWeChat/products?apikey=' + process.env.apikey; // 根据品类查询商品
const product = 'msWeChat/product?apikey=' + process.env.apikey; // 根据品类查询商品
const mainCategories = 'msWeChat/mainCategories?apikey=' + process.env.apikey;
const childrenCategories = 'msWeChat/childrenCategories?apikey=' + process.env.apikey;
const scan = 'msWeChat/scan?apikey=' + process.env.apikey;
const cancelCollection = 'msWeChat/cancelCollection?apikey=' + process.env.apikey;
const collection = 'msWeChat/collection?apikey=' + process.env.apikey;


let server = testServer;
let customerType = normalCustomerType;
const ENV = {};
if (Object.keys(ENV).length === 0) {
    ENV.TEST_AND_NORMAL = 0;
    ENV.TEST_AND_RDM = 1;
    ENV.PROD_AND_NORMAL = 2;
    ENV.PROD_AND_RDM = 3;
    // ENV.PROD_AND_NORMAL = 2;  // 生产环境普通版本
    // ENV.PROD_AND_RDM = 3; // 生产环境RDM版本
}
//注意：修改环境配置的在这里 //todo
const setEnv = ENV.PROD_AND_NORMAL;
switch (setEnv) {
    case ENV.TEST_AND_NORMAL:
        server = testServer;
        customerType = normalCustomerType;
        break;
    case ENV.TEST_AND_RDM:
        server = testServer;
        customerType = rdmCustomerType;
        break;
    case ENV.PROD_AND_NORMAL:
        server = prdServer;
        customerType = normalCustomerType;
        break;
    case ENV.PROD_AND_RDM:
        server = prdServer;
        customerType = rdmCustomerType;
        break;
    default:
        break;
}

const apiConfig = {
    serverAddress: server,
    customerType: customerType,
    searchProduct: searchProduct,
    myBrowsingHistory: myBrowsingHistory,
    myCollections: myCollections,
    products: products,
    mainCategories: mainCategories,
    childrenCategories: childrenCategories,
    product: product,
    scan: scan,
    cancelCollection: cancelCollection,
    collection: collection,
    
};

export default apiConfig




// WEBPACK FOOTER //
// ./src/api.js